import { Container } from "@mui/material";
import { useContext, useEffect } from "react";
import SEO from "../components/SEO";
import CONFIG from "../config";
import { SiteStateContext } from "../contexts/SiteStateContext";
import gaEvents from "../util/gaEvent";
import { fixSiteState } from "../util/site_state";

export function NewsletterPage() {
    const { setSiteState } = useContext(SiteStateContext);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(fixSiteState({ title: "Newsletter", navHighlight: "/newsletter", hideFooter: true }));
        }
    }, [setSiteState]);

    gaEvents.newsletter.newsletter_redirect();

    window.location.href = CONFIG.newsletter.url;

    return (
        <Container sx={{ mt: "60px", textAlign: "center" }}>
            <SEO 
                title="Newsletter - River Hawk Chapter"
                description="Subscribe to the River Hawk Chapter newsletter for updates on events, service opportunities, and chapter news."
                keywords="River Hawk Newsletter, OA Newsletter, Scout Newsletter, Chapter Newsletter, Order of the Arrow Updates"
            />
            Redirecting...
        </Container>
    );
}
